import { LogOut, Moon, Settings, Sun, SunMoon, User } from "lucide-react";
import { Link } from "react-router-dom";

import { useLogout } from "@/api/logout";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { SwitchOrganisation } from "@/features/select-organisation/components/switch-organisation";
import { cn } from "@/lib/utils";

import { useTheme } from "./theme-provider";
import { UserProfileButton } from "./user-profile-button";

export function UserProfileMenu() {
  const { mutateAsync: logout } = useLogout();
  const { theme, setTheme } = useTheme();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <UserProfileButton />
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-64 rounded-2xl border border-border bg-card">
        <DropdownMenuGroup className="rounded-xl border border-border bg-background p-1 px-1">
          <DropdownMenuItem className="text-sm" disabled>
            <User />
            <span>Profile</span>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <Link to="/account-settings" className="cursor-pointer">
              <Settings />
              <span>Account Settings</span>
            </Link>
          </DropdownMenuItem>

          <DropdownMenuSub>
            <DropdownMenuSubTrigger>
              <Sun />
              <span>Theme</span>
            </DropdownMenuSubTrigger>
            <DropdownMenuPortal>
              <DropdownMenuSubContent>
                <DropdownMenuItem
                  onClick={() => setTheme("light")}
                  className={cn(
                    theme === "light" && "bg-background",
                    "cursor-pointer",
                  )}
                >
                  <Sun />
                  <span>Light</span>
                </DropdownMenuItem>
                <DropdownMenuItem
                  onClick={() => setTheme("dark")}
                  className={cn(
                    theme === "dark" && "bg-background",
                    "cursor-pointer",
                  )}
                >
                  <Moon />
                  <span>Dark</span>
                </DropdownMenuItem>
                <DropdownMenuItem
                  onClick={() => setTheme("system")}
                  className={cn(
                    theme === "system" && "bg-background",
                    "cursor-pointer",
                  )}
                >
                  <SunMoon />
                  <span>System</span>
                </DropdownMenuItem>
              </DropdownMenuSubContent>
            </DropdownMenuPortal>
          </DropdownMenuSub>
          <SwitchOrganisation />
        </DropdownMenuGroup>

        <DropdownMenuItem
          onClick={() => logout()}
          className="mb-2 mt-4 cursor-pointer"
        >
          <LogOut />
          <span>Log out</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
